import React, { useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import MyAccountSidebar from "../../components/MyAccountSidebar";
import helpers from "../../utils/helpers"
import AuthContext from '../../context/AuthContext'
import Breadcrumbs from './Breadcrumbs';
const MyAccountSummary = () => {

  let {user_coins } = useContext(AuthContext);
  return (
    <div className="top-header-inner">
      <section className="py-4 main-inner-outer">
        <Container fluid>
        <Breadcrumbs />

          <Row>
            <Col lg={2}>
              <MyAccountSidebar />
            </Col>
            <Col lg={10} md={12}>
              <div className="inner-wrapper">
                {/* account-summary */}

                <h2 className="common-heading">Account Summary</h2>

                <div className="bg-white py-2 px-3 total-balance-summary">
                  <div className="first_cols">
                  <dt>Your Balances</dt>
                  <strong>
                    {helpers.currencyFormat(user_coins)} <sub>PBU</sub>
                  </strong>
                  </div>
                </div>

                {/* account-summary */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default MyAccountSummary;
